export enum Interests {
  ACTIVISM = 'ACTIVISM',
  AEROSPACE = 'AEROSPACE',
  AI = 'AI',
  ALTERNATIVE_ENERGY = 'ALTERNATIVE_ENERGY',
  ANTHROPOLOGY = 'ANTHROPOLOGY',
  ARCHAEOLOGY = 'ARCHAEOLOGY',
  ARCHITECTURE = 'ARCHITECTURE',
  ART = 'ART',
  ASTRONOMY = 'ASTRONOMY',
  ASTROPHYSICS = 'ASTROPHYSICS',
  AUTISM = 'AUTISM',
  AVIATION = 'AVIATION',
  BIOLOGY = 'BIOLOGY',
  BLOCKCHAIN = 'BLOCKCHAIN',
  BUSINESS = 'BUSINESS',
  CIVIL_RIGHTS = 'CIVIL_RIGHTS',
  CLIMATE_CHANGE = 'CLIMATE_CHANGE',
  CRYPTO = 'CRYPTO',
  CULTURAL_STUDIES = 'CULTURAL_STUDIES',
  CULTURE = 'CULTURE',
  CYBERSECURITY = 'CYBERSECURITY',
  DATA_SCIENCE = 'DATA_SCIENCE',
  DESIGN = 'DESIGN',
  DRONES = 'DRONES',
  EDUCATION = 'EDUCATION',
  ENGINEERING = 'ENGINEERING',
  ENTREPRENEURSHIP = 'ENTREPRENEURSHIP',
  ENVIRONMENT = 'ENVIRONMENT',
  EQUALITY = 'EQUALITY',
  ESA = 'ESA',
  ETHICS = 'ETHICS',
  FILM = 'FILM',
  FINANCE = 'FINANCE',
  FOREIGN_POLICY = 'FOREIGN_POLICY',
  GENETICS = 'GENETICS',
  GEOLOGY = 'GEOLOGY',
  GEOPOLITICS = 'GEOPOLITICS',
  GOVERNMENT = 'GOVERNMENT',
  HEALTH = 'HEALTH',
  HEALTHCARE = 'HEALTHCARE',
  HISTORY = 'HISTORY',
  HUMAN_RIGHTS = 'HUMAN_RIGHTS',
  INVESTIGATIVE_JOURNALISM = 'INVESTIGATIVE_JOURNALISM',
  IOT = 'IOT',
  JOURNALISM = 'JOURNALISM',
  LAW = 'LAW',
  LINGUISTICS = 'LINGUISTICS',
  LITERATURE = 'LITERATURE',
  MARKETS = 'MARKETS',
  MATHEMATICS = 'MATHEMATICS',
  MEDIA_LITERACY = 'MEDIA_LITERACY',
  MEDICAL_TECH = 'MEDICAL_TECH',
  MENTAL_HEALTH = 'MENTAL_HEALTH',
  MILITARY = 'MILITARY',
  MOBILE_DEVELOPMENT = 'MOBILE_DEVELOPMENT',
  MUSIC = 'MUSIC',
  NASA = 'NASA',
  NEUROSCIENCE = 'NEUROSCIENCE',
  NUTRITION = 'NUTRITION',
  PALEONTOLOGY = 'PALEONTOLOGY',
  PHILOSOPHY = 'PHILOSOPHY',
  PHYSICS = 'PHYSICS',
  POETRY = 'POETRY',
  POLITICS = 'POLITICS',
  PROGRAMMING = 'PROGRAMMING',
  PSYCHOLOGY = 'PSYCHOLOGY',
  RELIGION = 'RELIGION',
  RENEWABLE_ENERGY = 'RENEWABLE_ENERGY',
  ROBOTICS = 'ROBOTICS',
  SCIENCE = 'SCIENCE',
  SECURITY = 'SECURITY',
  SOCIAL_ISSUES = 'SOCIAL_ISSUES',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  SOCIOLOGY = 'SOCIOLOGY',
  SOLAR_ENERGY = 'SOLAR_ENERGY',
  SPACE = 'SPACE',
  STOCK_MARKET = 'STOCK_MARKET',
  SUSTAINABILITY = 'SUSTAINABILITY',
  TECHNOLOGY = 'TECHNOLOGY',
  TRANSPORTATION = 'TRANSPORTATION',
  URBAN_PLANNING = 'URBAN_PLANNING',
  UX_UI = 'UX_UI',
  VIRTUAL_REALITY = 'VIRTUAL_REALITY',
  WAR = 'WAR',
  WEB_DEVELOPMENT = 'WEB_DEVELOPMENT',
}
